import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { langToCountryCode } from "../../../../helper/lang";
import ReactCountryFlag from "react-country-flag";

interface LanguageLabelProps {
  lang: string;
}

const LanguageLabel = ({ lang }: LanguageLabelProps): ReactElement => {
  const { t } = useTranslation();
  const label = t(`lang_${lang}`);
  const country = (langToCountryCode[lang] || lang).toUpperCase();

  return (
    <Label>
      <FlagIcon
        countryCode={country}
        svg
        aria-label={label}
        title={label}
      />
      {label}
    </Label>
  );
};

const Label = styled.div`
  display: flex;
  align-items: center;
`;

// Style the flag component directly (react-country-flag renders a span/svg, not img)
const FlagIcon = styled(ReactCountryFlag)`
  margin-right: 10px;
  width: 24px;
  height: 24px;
  border-radius: 3px;
  object-fit: cover;
  line-height: 1; /* avoids vertical misalignment */
`;

export default LanguageLabel;
